//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken, Type } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { ActiveProblem, ApproveCutterOverrideRequestDto, AssignedSubApplications, BitBreaker, Communication, CreateCutterOverrideRequestDto, CutterMap, CutterOverrideRequest, DenyCutterOverrideRequestDto, EquipmentTemplateRequest, EstimatedCostSavings, Field_MudType, FileVaultListItem, FixedCutterBrazedIn, FixedCutterCastIn, FixedCutterGaugePadElement, FixedCutterNozzleDummy, FixedCutterNozzleLiner, FixedCutterPowder, FixedCutterRingGauge, FixedCutterSleeve, MarketingSheetCutterDto, MaterialMasterPurchasePartRequest, MaterialMasterRequest, MaterialMasterUpdateRequest, ORD_Order, PatchORDArmDto, PatchORDBitDto, PatchORDCerebroDto, PatchORDCutterMapDto, PatchOrderCommunictionDto, PatchOrderTaskDto, PatchORDGaugeProtectionDto, PatchORDOrderDto, PatchORDPowderDto, PatchORDUppersectionDto, PatchRollerConeDto, PDCCutter, Picklist, ReturnViewModel, RingGauge, RTAOptions, RtaType, SOCreateReturnPayload, SubApplicationLabels, SubApplicationSearchOptions, Uppersection, ValidateOverrideCodeDto, TaskViewModel, IPatchOrderTaskDto, SapNumType } from '../interfaces/request.interface';
import { AvailableCutter, CutterGroup } from '../interfaces/cutterMap';
import { BomPartTypeLayout } from '../interfaces/request';

declare var CURRENT_USER_ID: number;
declare var CURRENT_USER_LOGINID: string;
declare var CURRENT_USER_DISPLAYNAME: string;
declare var DBSService_BASE_URL: string;


@Injectable({
    providedIn: 'root'
})

export class RTAApiClient {
    public $CURRENT_USER_LOGINID: string = CURRENT_USER_LOGINID;
    public $CURRENT_USER_ID: number = CURRENT_USER_ID;
    public $CURRENT_USER_DISPLAYNAME: string = CURRENT_USER_DISPLAYNAME;
    private http: HttpClient;
    private baseUrl: string = DBSService_BASE_URL;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient) {
        this.http = http;
    }

    /**
     * @param isActive (optional) 
     * @return OK
     */
    getAssignedSubApplications(key: number, isActive: boolean | undefined): Observable<AssignedSubApplications[]> {
        let url_ = this.baseUrl + "/api/ADesc/GetAssignedSubApplications/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetAssignedSubApplications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssignedSubApplications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssignedSubApplications[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssignedSubApplications[]>;
        }));
    }

    protected processGetAssignedSubApplications(response: HttpResponseBase): Observable<AssignedSubApplications[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(AssignedSubApplications.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AssignedSubApplications[]>([]);
    }

    /**
     * @return OK
     */
    getActiveProblems(): Observable<ActiveProblem[]> {
        let url_ = this.baseUrl + "/api/ADesc/GetActiveProblems";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetActiveProblems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveProblems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveProblem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveProblem[]>;
        }));
    }

    protected processGetActiveProblems(response: HttpResponseBase): Observable<ActiveProblem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ActiveProblem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ActiveProblem[]>([]);
    }

    /**
     * @return OK
     */
    getMudtypes(): Observable<Field_MudType[]> {
        let url_ = this.baseUrl + "/api/ADesc/GetMudtypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMudtypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMudtypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Field_MudType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Field_MudType[]>;
        }));
    }

    protected processGetMudtypes(response: HttpResponseBase): Observable<Field_MudType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Field_MudType.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Field_MudType[]>([]);
    }

    /**
     * @return OK
     */
    getSubApplicationLabels(key: number): Observable<SubApplicationLabels> {
        let url_ = this.baseUrl + "/api/ADesc/GetSubApplicationLabels/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetSubApplicationLabels(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubApplicationLabels(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubApplicationLabels>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubApplicationLabels>;
        }));
    }

    protected processGetSubApplicationLabels(response: HttpResponseBase): Observable<SubApplicationLabels> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SubApplicationLabels.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubApplicationLabels>(null as any);
    }

    /**
     * @return OK
     */
    subApplicationParameterLimits(key: number): Observable<SubApplicationSearchOptions> {
        let url_ = this.baseUrl + "/api/ADesc/SubApplicationParameterLimits/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processSubApplicationParameterLimits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubApplicationParameterLimits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubApplicationSearchOptions>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubApplicationSearchOptions>;
        }));
    }

    protected processSubApplicationParameterLimits(response: HttpResponseBase): Observable<SubApplicationSearchOptions> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SubApplicationSearchOptions.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SubApplicationSearchOptions>(null as any);
    }

    /**
     * @return OK
     */
    common(id: string): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/rta_Common/User({id})";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCommon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCommon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processCommon(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @return OK
     */
    users(): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/rta_Common/Users()";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processUsers(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @return OK
     */
    productLines(): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/rta_Common/ProductLines";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processProductLines(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductLines(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processProductLines(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @return OK
     */
    getBitSummaries(): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/rta_Common/GetBitSummaries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBitSummaries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBitSummaries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processGetBitSummaries(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @return OK
     */
    getBitSummary(key: number): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/rta_Common/GetBitSummary/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBitSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBitSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processGetBitSummary(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @return OK
     */
    getPickList(): Observable<Picklist[]> {
        let url_ = this.baseUrl + "/api/rta_Common/GetPickList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPickList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPickList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Picklist[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Picklist[]>;
        }));
    }

    protected processGetPickList(response: HttpResponseBase): Observable<Picklist[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Picklist.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Picklist[]>([]);
    }

    /**
     * @return OK
     */
    orders(): Observable<ORD_Order[]> {
        let url_ = this.baseUrl + "/api/Orders/Orders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ORD_Order[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ORD_Order[]>;
        }));
    }

    protected processOrders(response: HttpResponseBase): Observable<ORD_Order[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ORD_Order.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ORD_Order[]>([]);
    }

    /**
     * @return OK
     */
    rTA(id: string): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/RTA/GetOrderData({id})";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRTA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRTA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processRTA(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param id (optional) 
     * @return OK
     */
    rTA2(id: number | undefined, key: string): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/RTA/BuildReportCutterMap({key})?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRTA2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRTA2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processRTA2(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @return OK
     */
    types(): Observable<RtaType[]> {
        let url_ = this.baseUrl + "/api/RTA/Types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RtaType[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RtaType[]>;
        }));
    }

    protected processTypes(response: HttpResponseBase): Observable<RtaType[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(RtaType.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RtaType[]>([]);
    }

    /**
     * @param forDetailsPage (optional) 
     * @param permissionLock (optional) 
     * @param autoMapper (optional) 
     * @return OK
     */
    buildCutterMap(key: number, forDetailsPage: boolean | undefined, permissionLock: boolean | undefined, autoMapper: boolean | undefined): Observable<CutterMap> {
        let url_ = this.baseUrl + "/api/RTA/BuildCutterMap/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (forDetailsPage === null)
            throw new Error("The parameter 'forDetailsPage' cannot be null.");
        else if (forDetailsPage !== undefined)
            url_ += "forDetailsPage=" + encodeURIComponent("" + forDetailsPage) + "&";
        if (permissionLock === null)
            throw new Error("The parameter 'permissionLock' cannot be null.");
        else if (permissionLock !== undefined)
            url_ += "permissionLock=" + encodeURIComponent("" + permissionLock) + "&";
        if (autoMapper === null)
            throw new Error("The parameter 'autoMapper' cannot be null.");
        else if (autoMapper !== undefined)
            url_ += "autoMapper=" + encodeURIComponent("" + autoMapper) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processBuildCutterMap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuildCutterMap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CutterMap>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CutterMap>;
        }));
    }

    protected processBuildCutterMap(response: HttpResponseBase): Observable<CutterMap> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CutterMap.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CutterMap>(null as any);
    }

    /**
     * @return OK
     */
    getEstimatedCostSavings(key: number): Observable<EstimatedCostSavings> {
        let url_ = this.baseUrl + "/api/RTA/GetEstimatedCostSavings/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEstimatedCostSavings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEstimatedCostSavings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EstimatedCostSavings>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EstimatedCostSavings>;
        }));
    }

    protected processGetEstimatedCostSavings(response: HttpResponseBase): Observable<EstimatedCostSavings> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = EstimatedCostSavings.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<EstimatedCostSavings>(null as any);
    }

    /**
     * @return OK
     */
    retreiveOrderOptions(key: number): Observable<RTAOptions[]> {
        let url_ = this.baseUrl + "/api/RTA/RetreiveOrderOptions/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processRetreiveOrderOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetreiveOrderOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RTAOptions[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RTAOptions[]>;
        }));
    }

    protected processRetreiveOrderOptions(response: HttpResponseBase): Observable<RTAOptions[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(RTAOptions.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RTAOptions[]>([]);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    upsertOrder(key: number, userId: number | undefined, body: Partial<PatchORDOrderDto> | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/RTA/UpsertOrder/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpsertOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processUpsertOrder(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    upsertOrderBit(key: number, userId: number | undefined, body: PatchORDBitDto | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/RTA/UpsertOrderBit/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpsertOrderBit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertOrderBit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processUpsertOrderBit(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    upsertOrderCerebro(key: number, userId: number | undefined, body: PatchORDCerebroDto | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/RTA/UpsertOrderCerebro/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpsertOrderCerebro(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertOrderCerebro(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processUpsertOrderCerebro(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateOrderUpperSection(key: number, userId: number | undefined, body: PatchORDUppersectionDto | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/RTA/UpdateOrderUpperSection/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateOrderUpperSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderUpperSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processUpdateOrderUpperSection(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateOrderGaugeProtection(key: number, userId: number | undefined, body: PatchORDGaugeProtectionDto[] | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/RTA/UpdateOrderGaugeProtection/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateOrderGaugeProtection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderGaugeProtection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processUpdateOrderGaugeProtection(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateOrderPowder(key: number, userId: number | undefined, body: PatchORDPowderDto[] | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/RTA/UpdateOrderPowder/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateOrderPowder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderPowder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processUpdateOrderPowder(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postOrderCommunication(key: number, body: PatchOrderCommunictionDto | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/RTA/PostOrderCommunication/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPostOrderCommunication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostOrderCommunication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processPostOrderCommunication(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param body (optional) 
     * @return OK
     */
    updateOrderTask(key: number, body: IPatchOrderTaskDto): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/RTA/UpdateOrderTask/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (CURRENT_USER_ID === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (CURRENT_USER_ID !== undefined)
            url_ += "userId=" + encodeURIComponent("" + CURRENT_USER_ID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        console.log("UpdateOrderTask: ", body);
        const content_ = JSON.stringify(body);
        console.log("UpdateOrderTask: ", content_);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateOrderTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processUpdateOrderTask(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @return OK
     */
    getFileVaultList(key: number): Observable<FileVaultListItem[]> {
        let url_ = this.baseUrl + "/api/RTA/GetFileVaultList/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetFileVaultList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFileVaultList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileVaultListItem[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileVaultListItem[]>;
        }));
    }

    protected processGetFileVaultList(response: HttpResponseBase): Observable<FileVaultListItem[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(FileVaultListItem.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileVaultListItem[]>([]);
    }

    /**
     * @return OK
     */
    getUpperSections(): Observable<Uppersection[]> {
        let url_ = this.baseUrl + "/api/RTA/GetUpperSections";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetUpperSections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUpperSections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Uppersection[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Uppersection[]>;
        }));
    }

    protected processGetUpperSections(response: HttpResponseBase): Observable<Uppersection[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Uppersection.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Uppersection[]>([]);
    }

    getSapNumberTypes(): Observable<SapNumType[]> {
        return this.http.get<SapNumType[]>(`${this.baseUrl}/api/RTA/GetSapNumberTypes`);
    }

    /**
     * @param orderId (optional) 
     * @return OK
     */
    getBitBreakersByUppersection(key: number, orderId: number | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/RTA/GetBitBreakersByUppersection/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBitBreakersByUppersection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBitBreakersByUppersection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processGetBitBreakersByUppersection(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @return OK
     */
    getBitBreakers(): Observable<BitBreaker[]> {
        let url_ = this.baseUrl + "/api/RTA/GetBitBreakers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetBitBreakers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBitBreakers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BitBreaker[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BitBreaker[]>;
        }));
    }

    protected processGetBitBreakers(response: HttpResponseBase): Observable<BitBreaker[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(BitBreaker.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<BitBreaker[]>([]);
    }

    /**
     * @return OK
     */
    getRingGaugesByBitSize(key: number): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/RTA/GetRingGaugesByBitSize/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRingGaugesByBitSize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRingGaugesByBitSize(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processGetRingGaugesByBitSize(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @return OK
     */
    getRingGauges(): Observable<RingGauge[]> {
        let url_ = this.baseUrl + "/api/RTA/GetRingGauges";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetRingGauges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRingGauges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RingGauge[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RingGauge[]>;
        }));
    }

    protected processGetRingGauges(response: HttpResponseBase): Observable<RingGauge[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(RingGauge.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RingGauge[]>([]);
    }

    /**
     * @param isActive (optional) 
     * @return OK
     */
    getPDCCutters(isActive: boolean | undefined): Observable<PDCCutter[]> {
        let url_ = this.baseUrl + "/api/RTA/GetPDCCutters?";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "isActive=" + encodeURIComponent("" + isActive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetPDCCutters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPDCCutters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PDCCutter[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PDCCutter[]>;
        }));
    }

    protected processGetPDCCutters(response: HttpResponseBase): Observable<PDCCutter[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(PDCCutter.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PDCCutter[]>([]);
    }

    /**
     * @return OK
     */
    getOrderCommunications(key: number): Observable<Communication[]> {
        let url_ = this.baseUrl + "/api/RTA/GetOrderCommunications/{key}";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetOrderCommunications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderCommunications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Communication[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Communication[]>;
        }));
    }

    protected processGetOrderCommunications(response: HttpResponseBase): Observable<Communication[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(Communication.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Communication[]>([]);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createMaterialMasterBits(body: MaterialMasterRequest | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/SAPMiddleware/CreateMaterialMasterBits";
        url_ = url_.replace(/[?&]$/, "");
console.log("createMaterialMasterBits body: ", body);
        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateMaterialMasterBits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMaterialMasterBits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processCreateMaterialMasterBits(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createMassMaterialMasterDataGenericPart(body: MaterialMasterPurchasePartRequest[] | undefined): Observable<ReturnViewModel[]> {
        let url_ = this.baseUrl + "/api/SAPMiddleware/CreateMassMaterialMasterDataGenericPart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateMassMaterialMasterDataGenericPart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMassMaterialMasterDataGenericPart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel[]>;
        }));
    }

    protected processCreateMassMaterialMasterDataGenericPart(response: HttpResponseBase): Observable<ReturnViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ReturnViewModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel[]>([]);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createMaterialMasterDataGenericPart(body: MaterialMasterPurchasePartRequest | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/SAPMiddleware/CreateMaterialMasterDataGenericPart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateMaterialMasterDataGenericPart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMaterialMasterDataGenericPart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processCreateMaterialMasterDataGenericPart(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createServiceMaterialMasterData(body: MaterialMasterRequest | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/SAPMiddleware/CreateServiceMaterialMasterData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateServiceMaterialMasterData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateServiceMaterialMasterData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processCreateServiceMaterialMasterData(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    updateMaterialMaster(body: MaterialMasterUpdateRequest | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/SAPMiddleware/UpdateMaterialMaster";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateMaterialMaster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMaterialMaster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processUpdateMaterialMaster(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param materialNumber (optional) 
     * @return OK
     */
    getMaterialMaster(materialNumber: string | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/SAPMiddleware/GetMaterialMaster?";
        if (materialNumber === null)
            throw new Error("The parameter 'materialNumber' cannot be null.");
        else if (materialNumber !== undefined)
            url_ += "materialNumber=" + encodeURIComponent("" + materialNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaterialMaster(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialMaster(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processGetMaterialMaster(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createEquipmentTemplate(body: EquipmentTemplateRequest | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/SAPMiddleware/CreateEquipmentTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateEquipmentTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEquipmentTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processCreateEquipmentTemplate(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createSerialNumber(body: EquipmentTemplateRequest | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/SAPMiddleware/CreateSerialNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateSerialNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSerialNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processCreateSerialNumber(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param equipmentNumber (optional) 
     * @return OK
     */
    getEquipmentTemplate(equipmentNumber: string | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/SAPMiddleware/GetEquipmentTemplate?";
        if (equipmentNumber === null)
            throw new Error("The parameter 'equipmentNumber' cannot be null.");
        else if (equipmentNumber !== undefined)
            url_ += "EquipmentNumber=" + encodeURIComponent("" + equipmentNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetEquipmentTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEquipmentTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processGetEquipmentTemplate(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param drawingName (optional) 
     * @param description (optional) 
     * @param userId (optional) 
     * @param rtaNum (optional) 
     * @return OK
     */
    createDrawing(drawingName: string | undefined, description: string | undefined, userId: number | undefined, rtaNum: number | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/SAPMiddleware/CreateDrawing?";
        if (drawingName === null)
            throw new Error("The parameter 'drawingName' cannot be null.");
        else if (drawingName !== undefined)
            url_ += "DrawingName=" + encodeURIComponent("" + drawingName) + "&";
        if (description === null)
            throw new Error("The parameter 'description' cannot be null.");
        else if (description !== undefined)
            url_ += "Description=" + encodeURIComponent("" + description) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (rtaNum === null)
            throw new Error("The parameter 'rtaNum' cannot be null.");
        else if (rtaNum !== undefined)
            url_ += "rtaNum=" + encodeURIComponent("" + rtaNum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateDrawing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDrawing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processCreateDrawing(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param rtaNum (optional) 
     * @return OK
     */
    processRTADrawings(userId: number | undefined, rtaNum: number | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/SAPMiddleware/ProcessRTADrawings?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (rtaNum === null)
            throw new Error("The parameter 'rtaNum' cannot be null.");
        else if (rtaNum !== undefined)
            url_ += "rtaNum=" + encodeURIComponent("" + rtaNum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processProcessRTADrawings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessRTADrawings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processProcessRTADrawings(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param materialNumber (optional) 
     * @param plant (optional) 
     * @return OK
     */
    getMaterialBoM(materialNumber: string | undefined, plant: string | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/SAPMiddleware/GetMaterialBoM?";
        if (materialNumber === null)
            throw new Error("The parameter 'materialNumber' cannot be null.");
        else if (materialNumber !== undefined)
            url_ += "materialNumber=" + encodeURIComponent("" + materialNumber) + "&";
        if (plant === null)
            throw new Error("The parameter 'plant' cannot be null.");
        else if (plant !== undefined)
            url_ += "plant=" + encodeURIComponent("" + plant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processGetMaterialBoM(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaterialBoM(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processGetMaterialBoM(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param productionOrder (optional) 
     * @param materialNumber (optional) 
     * @param user_Id (optional) 
     * @return OK
     */
    updateProductionOrderBoM(productionOrder: string | undefined, materialNumber: string | undefined, user_Id: number | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/SAPMiddleware/UpdateProductionOrderBoM?";
        if (productionOrder === null)
            throw new Error("The parameter 'productionOrder' cannot be null.");
        else if (productionOrder !== undefined)
            url_ += "productionOrder=" + encodeURIComponent("" + productionOrder) + "&";
        if (materialNumber === null)
            throw new Error("The parameter 'materialNumber' cannot be null.");
        else if (materialNumber !== undefined)
            url_ += "materialNumber=" + encodeURIComponent("" + materialNumber) + "&";
        if (user_Id === null)
            throw new Error("The parameter 'user_Id' cannot be null.");
        else if (user_Id !== undefined)
            url_ += "User_Id=" + encodeURIComponent("" + user_Id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateProductionOrderBoM(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductionOrderBoM(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processUpdateProductionOrderBoM(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param targetId (optional) 
     * @param user_Id (optional) 
     * @return OK
     */
    createMaterialBom(targetId: number | undefined, user_Id: number | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/SAPMiddleware/CreateMaterialBom?";
        if (targetId === null)
            throw new Error("The parameter 'targetId' cannot be null.");
        else if (targetId !== undefined)
            url_ += "TargetId=" + encodeURIComponent("" + targetId) + "&";
        if (user_Id === null)
            throw new Error("The parameter 'user_Id' cannot be null.");
        else if (user_Id !== undefined)
            url_ += "User_Id=" + encodeURIComponent("" + user_Id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processCreateMaterialBom(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateMaterialBom(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processCreateMaterialBom(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param targetId (optional) 
     * @param materialnumber (optional) 
     * @param user_Id (optional) 
     * @return OK
     */
    updateMaterialBoM(targetId: number | undefined, materialnumber: number | undefined, user_Id: number | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/SAPMiddleware/UpdateMaterialBoM?";
        if (targetId === null)
            throw new Error("The parameter 'targetId' cannot be null.");
        else if (targetId !== undefined)
            url_ += "TargetId=" + encodeURIComponent("" + targetId) + "&";
        if (materialnumber === null)
            throw new Error("The parameter 'materialnumber' cannot be null.");
        else if (materialnumber !== undefined)
            url_ += "materialnumber=" + encodeURIComponent("" + materialnumber) + "&";
        if (user_Id === null)
            throw new Error("The parameter 'user_Id' cannot be null.");
        else if (user_Id !== undefined)
            url_ += "User_Id=" + encodeURIComponent("" + user_Id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateMaterialBoM(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMaterialBoM(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processUpdateMaterialBoM(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postSOCreate(body: SOCreateReturnPayload | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/api/SAPMiddleware/PostSOCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processPostSOCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostSOCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        }));
    }

    protected processPostSOCreate(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ReturnViewModel.fromJS(resultData200);
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel>(null as any);
    }
    updateOrderCutterMap(
        key: number,
        userId: number | undefined,
        body: PatchORDCutterMapDto[] | undefined
    ): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + '/api/RTA/UpdateOrderCutterMap/{key}';
        url_ = url_.replace('{key}', encodeURIComponent('' + key));
        console.log(JSON.stringify(body))
        if (userId !== undefined && userId !== null) {
            url_ += '?userId=' + encodeURIComponent('' + userId);
        }
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);
        const options_: any = {
            body: content_,
            observe: 'response' as const,
            responseType: 'blob' as const,
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'text/plain',
            }),
        };

        return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processUpdateOrderCutterMap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrderCutterMap(response_);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel>;
                }
            }
            return _observableThrow(response_) as any as Observable<ReturnViewModel>;
        })
        );
    }

    protected processUpdateOrderCutterMap(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                    ? (response as any).error
                    : undefined;

        const _headers: any = {};
        if (response.headers) {
            for (const key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: ReturnViewModel | null = null;
                    const resultData200 =
                        _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ReturnViewModel.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ReturnViewModel>(null as any);
    }
    /**
   * @param key Order key
   * @param sapNumber (optional)
   * @return AvailableCutter[]
   */
    public getAvailableCutters(
        key: number,
        sapNumber: number | undefined
    ): Observable<AvailableCutter[]> {
        let url_ = this.baseUrl + '/api/RTA/GetAvailableCutters/{key}?';
        if (key === undefined || key === null) {
            throw new Error("The parameter 'key' must be defined.");
        }
        url_ = url_.replace('{key}', encodeURIComponent('' + key));

        if (sapNumber === null) {
            throw new Error("The parameter 'sapNumber' cannot be null.");
        } else if (sapNumber !== undefined) {
            url_ += 'sapNumber=' + encodeURIComponent('' + sapNumber) + '&';
        }

        url_ = url_.replace(/[?&]$/, '');

        const options_: any = {
            observe: 'response' as const,
            responseType: 'blob' as const,
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetAvailableCutters(response_ as HttpResponseBase);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetAvailableCutters(response_);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<AvailableCutter[]>;
                        }
                    }
                    return _observableThrow(response_) as any as Observable<AvailableCutter[]>;
                })
            );
    }
    public upsertFixedCutterPowders(key: number, userId: number | undefined, body: FixedCutterPowder[] | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/FixedCutterInput/UpdateFixedCutterPowders/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResponse(response_);
        }));
    }
    public upsertFixedCutterSleeves(key: number, userId: number | undefined, body: FixedCutterSleeve[] | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/FixedCutterInput/UpdateFixedCutterSleeves/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResponse(response_);
        }));
    }

    public upsertFixedCutterRingGauges(key: number, userId: number | undefined, body: FixedCutterRingGauge[] | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/FixedCutterInput/UpdateFixedCutterRingGauges/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResponse(response_);
        }));
    }

    public upsertFixedCutterNozzleLiners(key: number, userId: number | undefined, body: FixedCutterNozzleLiner[] | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/FixedCutterInput/UpdateFixedCutterNozzleLiners/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResponse(response_);
        }));
    }

    public upsertFixedCutterNozzleDummies(key: number, userId: number | undefined, body: FixedCutterNozzleDummy[] | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/FixedCutterInput/UpdateFixedCutterNozzleDummies/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResponse(response_);
        }));
    }

    public upsertFixedCutterBrazedIns(key: number, userId: number | undefined, body: FixedCutterBrazedIn[] | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/FixedCutterInput/UpdateFixedCutterBrazedIns/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResponse(response_);
        }));
    }

    public upsertFixedCutterCastIns(key: number, userId: number | undefined, body: FixedCutterCastIn[] | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/FixedCutterInput/UpdateFixedCutterCastIns/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResponse(response_);
        }));
    }

    public upsertFixedCutterGaugePadElements(key: number, userId: number | undefined, body: FixedCutterGaugePadElement[] | undefined): Observable<ReturnViewModel> {
        let url_ = this.baseUrl + "/FixedCutterInput/UpdateFixedCutterGaugePadElements/{key}?";
        if (key === undefined || key === null)
            throw new Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);
        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processResponse(response_);
        }));
    }
    protected processResponse(response: HttpResponseBase): Observable<ReturnViewModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                    ? (response as any).error
                    : undefined;

        const _headers: any = {};
        if (response.headers) {
            for (const key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    let result200: ReturnViewModel | null = null;
                    const resultData200 =
                        _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    result200 = ReturnViewModel.fromJS(resultData200);
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap((_responseText: string) => {
                    return throwException('An unexpected server error occurred.', status, _responseText, _headers);
                })
            );
        }
        return _observableOf<ReturnViewModel>(null as any);
    }
    protected processGetAvailableCutters(
        response: HttpResponseBase
    ): Observable<AvailableCutter[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                    ? (response as any).error
                    : undefined;

        const _headers: any = {};
        if (response.headers) {
            for (const key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }

        if (status === 200) {
            return blobToText(responseBlob!).pipe(
                _observableMergeMap(_responseText => {
                    const resultData =
                        _responseText === ''
                            ? []
                            : JSON.parse(_responseText, this.jsonParseReviver) as AvailableCutter[];
                    return _observableOf(resultData);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob!).pipe(
                _observableMergeMap(_responseText => {
                    return throwException(
                        'An unexpected server error occurred.',
                        status,
                        _responseText,
                        _headers
                    );
                })
            );
        }
        return _observableOf<AvailableCutter[]>([]);
    }
    /**
   * @param key Order key
   * @return CutterGroup[]
   */
    public getCutterGroupByOrder(
        key: number
    ): Observable<CutterGroup[]> {
        let url_ = this.baseUrl + '/api/RTA/GetCutterGroupByOrder/{key}';
        if (key === undefined || key === null) {
            throw new Error("The parameter 'key' must be defined.");
        }
        url_ = url_.replace('{key}', encodeURIComponent('' + key));

        // no query params to append, so just strip any trailing '?' or '&'
        url_ = url_.replace(/[?&]$/, '');

        const options_: any = {
            observe: 'response' as const,
            responseType: 'blob' as const,
            headers: new HttpHeaders({
                Accept: 'text/plain'
            })
        };

        return this.http
            .request('get', url_, options_)
            .pipe(
                _observableMergeMap((response_: any) => {
                    return this.processGetCutterGroupByOrder(response_ as HttpResponseBase);
                })
            )
            .pipe(
                _observableCatch((response_: any) => {
                    if (response_ instanceof HttpResponseBase) {
                        try {
                            return this.processGetCutterGroupByOrder(response_);
                        } catch (e) {
                            return _observableThrow(e) as any as Observable<CutterGroup[]>;
                        }
                    }
                    return _observableThrow(response_) as any as Observable<CutterGroup[]>;
                })
            );
    }

    protected processGetCutterGroupByOrder(
        response: HttpResponseBase
    ): Observable<CutterGroup[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse
                ? response.body
                : (response as any).error instanceof Blob
                    ? (response as any).error
                    : undefined;

        const _headers: any = {};
        if (response.headers) {
            for (const headerName of response.headers.keys()) {
                _headers[headerName] = response.headers.get(headerName);
            }
        }

        if (status === 200) {
            return blobToText(responseBlob!).pipe(
                _observableMergeMap(_responseText => {
                    const resultData =
                        _responseText === ''
                            ? []
                            : (JSON.parse(_responseText, this.jsonParseReviver) as CutterGroup[]);
                    return _observableOf(resultData);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob!).pipe(
                _observableMergeMap(_responseText => {
                    return throwException(
                        'An unexpected server error occurred.',
                        status,
                        _responseText,
                        _headers
                    );
                })
            );
        }
        return _observableOf<CutterGroup[]>([]);
    }

    /**
 * @param key Order ID
 * @return OK
 */
    getOrderTasks(key: number): Observable<TaskViewModel[]> {
        let url_ = this.baseUrl + "/api/RTA/GetOrderTasks/" + encodeURIComponent("" + key);
        url_ = url_.replace(/[?&]$/, "");

        let options_: any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(
            _observableMergeMap((response_: any) => {
                return this.processGetOrderTasks(response_);
            })
        ).pipe(
            _observableCatch((response_: any) => {
                if (response_ instanceof HttpResponseBase) {
                    try {
                        return this.processGetOrderTasks(response_ as any);
                    } catch (e) {
                        return _observableThrow(e) as any as Observable<TaskViewModel[]>;
                    }
                } else {
                    return _observableThrow(response_) as any as Observable<TaskViewModel[]>;
                }
            })
        );
    }

    protected processGetOrderTasks(response: HttpResponseBase): Observable<TaskViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {};
        if (response.headers) {
            for (let key of response.headers.keys()) {
                _headers[key] = response.headers.get(key);
            }
        }

        if (status === 200) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap(_responseText => {
                    let result200: TaskViewModel[] = [];
                    const resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                    if (Array.isArray(resultData200)) {
                        result200 = resultData200.map(item => TaskViewModel.fromJS(item));
                    }
                    return _observableOf(result200);
                })
            );
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(
                _observableMergeMap(_responseText => {
                    return throwException("An unexpected server error occurred.", status, _responseText, _headers);
                })
            );
        }

        return _observableOf<TaskViewModel[]>([]);
    }
    startOrderTask(key: number): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/StartOrderTask/${key}?userId=${CURRENT_USER_ID}`, {});
    }

    completeOrderTask(key: number, notes: string): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/CompleteOrderTask/${key}?userId=${CURRENT_USER_ID}&Notes=${encodeURIComponent(notes??'')}`, {});
    }

    rollbackOrderTask(key: number): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/RollbackOrderTask/${key}`, {});
    }

    rollbackSubOrderTask(key: number): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/RollbackSubOrderTask/${key}`, {});
    }

    approveOrderTask(key: number): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/ApproveOrderTask/${key}?userId=${CURRENT_USER_ID}`, {});
    }

    rejectOrderTask(key: number, reason: string): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/RejectOrderTask/${key}?userId=${CURRENT_USER_ID}`, { reason });
    }

    addNewTask(taskTemplate: number, orderId: number, startQueue: boolean = true): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/AddNewTask?taskTemplate=${taskTemplate}&orderId=${orderId}&startQueue=${startQueue}`, {});
    }

    deleteOrderTask(taskId: number, orderId: number): Observable<ReturnViewModel> {
        return this.http.delete<ReturnViewModel>(`${this.baseUrl}/api/RTA/DeleteOrderTask/${taskId}?orderId=${orderId}`);
    }

    deleteOrderProcess(taskId: number, orderId: number): Observable<ReturnViewModel> {
        return this.http.delete<ReturnViewModel>(`${this.baseUrl}/api/RTA/DeleteOrderProcess/${taskId}?orderId=${orderId}`);
    }

    processRework(key: number, reworkProcesses: number[]): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/ProcessRework/${key}`, reworkProcesses);
    }

    processOnHold(key: number, reason: string, onHoldCat_Id: number, order_Id: number): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/ProcessOnHold/${key}`, {user_Id: CURRENT_USER_ID, reason: reason, onHoldCat_Id: onHoldCat_Id, order_Id: order_Id});
    }

    removeOnHold(key: number): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/RemoveOnHold/${key}`, {});
    }
    getPopulateSAPData(key: number): Observable<ReturnViewModel> {
        return this.http.get<ReturnViewModel>(`${this.baseUrl}/api/RTA/GetPopulateSAPData/${key}`);
    }
    getBomLayout(key: number): Observable<BomPartTypeLayout[]> {
        return this.http.get<BomPartTypeLayout[]>(`${this.baseUrl}/api/RTA/GetBomLayouts/${key}`);
    }

    createOverrideRequest(orderId: number, userId: number, dto: CreateCutterOverrideRequestDto): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/override-requests/${orderId}?userId=${userId}`, dto);
    }

    getOverrideRequests(orderId: number): Observable<CutterOverrideRequest[]> {
        return this.http.get<CutterOverrideRequest[]>(`${this.baseUrl}/api/RTA/override-requests/${orderId}`)
            .pipe(_observableMergeMap(response => {
                const mapped = Array.isArray(response) ? response.map(r => CutterOverrideRequest.fromJS(r)) : [];
                return _observableOf(mapped);
            }));
    }

    approveOverrideRequest(requestId: number, approverUserId: number, dto: ApproveCutterOverrideRequestDto): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/override-requests/${requestId}/approve?approverUserId=${approverUserId}`, dto);
    }

    denyOverrideRequest(requestId: number, approverUserId: number, dto: DenyCutterOverrideRequestDto): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/override-requests/${requestId}/deny?approverUserId=${approverUserId}`, dto);
    }

    cancelOverrideRequest(requestId: number): Observable<ReturnViewModel> {
        return this.http.delete<ReturnViewModel>(`${this.baseUrl}/api/RTA/override-requests/${requestId}`);
    }

    validateOverrideCode(dto: ValidateOverrideCodeDto): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/override-requests/validate`, dto);
    }

    generateSapData(requestId: number): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/SAPBuilder/${requestId}?userId=${CURRENT_USER_ID}`, {});
    }

    saveMarketingSheetCutters(dto: MarketingSheetCutterDto, requestId: number): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/UpsertMarketingCutters?orderId=${requestId}&loginId=${CURRENT_USER_LOGINID}`, dto);
    }

    getMarketingCutters(orderId: number): Observable<MarketingSheetCutterDto | null> {
        return this.http.get<MarketingSheetCutterDto | null>(`${this.baseUrl}/api/RTA/GetMarketingCutters/${orderId}`);
    }

    upsertOrderArm(key: number, userId: number, arm: PatchORDArmDto): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/UpsertOrderArm/${key}?userId=${userId}`, arm);
    }

    upsertRollerCone(key: number, userId: number, dto: PatchRollerConeDto): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/UpsertRollerCone/${key}?userId=${userId}`, dto);
    }

    saveBom(key: number, userId: number, dto: { items: { id: number; preBOMID: number; type: string; sapMaterialNumber: number; quantity: number }[] }): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(`${this.baseUrl}/api/RTA/SaveBom/${key}?userId=${userId}`, dto);
    }

    getApprovalActionInfo(token: string): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/api/RTA/ApprovalAction/${encodeURIComponent(token)}`);
    }

    executeApprovalAction(token: string, userId: number, reason?: string): Observable<ReturnViewModel> {
        return this.http.post<ReturnViewModel>(
            `${this.baseUrl}/api/RTA/ApprovalAction/${encodeURIComponent(token)}?userId=${userId}`,
            { reason: reason || null }
        );
    }

    /**
     * @param body (optional)
     * @return OK
     */
    fvCreateMassPartNumbers(body: MaterialMasterPurchasePartRequest[] | undefined, ecoId: string): Observable<ReturnViewModel[]> {
        let url_ = this.baseUrl + "/api/SAPMiddleware/fvCreateMassPartNumbers?";
        if (ecoId !== undefined && ecoId !== null)
            url_ += "ecoId=" + encodeURIComponent("" + ecoId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
            return this.processFvCreateMassPartNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFvCreateMassPartNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReturnViewModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReturnViewModel[]>;
        }));
    }

    protected processFvCreateMassPartNumbers(response: HttpResponseBase): Observable<ReturnViewModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
                (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } }
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                let result200: any = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [] as any;
                    for (let item of resultData200)
                        result200!.push(ReturnViewModel.fromJS(item));
                }
                else {
                    result200 = <any>null;
                }
                return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ReturnViewModel[]>([]);
    }
}



export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
